import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
const ComparisonSection = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-16 px-4 bg-white" data-id="element-121" data-mp="50w6ctir6g5x">
      <div className="container mx-auto max-w-5xl" data-id="element-122" data-mp="504kiaeyjwsu">
        <div className="text-center mb-12" data-id="element-123" data-mp="9yxwfyeljfqw">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-primary mb-4" data-id="element-124" data-mp="9xmkhbazz1op">
            {t.comparison.headline}
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-125" data-mp="11f2ov2fokc">
            {t.comparison.subheadline}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-126" data-mp="3igbyjdd9kzto">
          {/* The "Other" Way */}
          <div className="bg-sand-50 p-8 rounded-2xl shadow-sm border border-sand-200 opacity-90 hover:opacity-100 transition-opacity" data-id="element-127" data-mp="3ndkfjamoextc">
            <div className="flex items-center gap-3 mb-6 border-b border-sand-200 pb-4" data-id="element-128" data-mp="38hv2i1zgxv0r">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center" data-id="element-129" data-mp="3dfobf2s5p34q">
                <XCircleIcon className="w-6 h-6 text-red-500" data-id="element-130" data-mp="z665fe73vez5" />
              </div>
              <h3 className="font-bold text-xl text-gray-800" data-id="element-131" data-mp="u7urosdowkbn">
                {t.comparison.badTitle}
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-132" data-mp="1862xlpspevyy">
              {t.comparison.badPoints.map((point, index) => <li key={index} className="flex items-start gap-3 text-gray-600" data-id="element-133" data-mp="144zjb7qb17zu" data-mpi={index}>
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-134" data-mp="bixyysxxxzvj" />
                  <span data-id="element-135" data-mp="pa32i64fjcb5">{point}</span>
                </li>)}
            </ul>
          </div>

          {/* Pedro's Way */}
          <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-success/20 relative transform md:-translate-y-4" data-id="element-136" data-mp="ki1k02go4pco">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-success text-white px-4 py-1 rounded-full text-sm font-bold shadow-md whitespace-nowrap" data-id="element-137" data-mp="3swjxwktaiz47">
              {t.comparison.goodBadge}
            </div>
            <div className="flex items-center gap-3 mb-6 border-b border-gray-100 pb-4" data-id="element-138" data-mp="1wv8aecpesoyh">
              <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center" data-id="element-139" data-mp="21mi0tfis7wbf">
                <CheckCircleIcon className="w-6 h-6 text-success" data-id="element-140" data-mp="26l1mrfxdl83s" />
              </div>
              <h3 className="font-bold text-xl text-primary" data-id="element-141" data-mp="18xkjbemea3jq">
                {t.comparison.goodTitle}
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-142" data-mp="1dxp1ra6v58cl">
              {t.comparison.goodPoints.map((point, index) => <li key={index} className="flex items-start gap-3 text-gray-800 font-medium" data-id="element-143" data-mp="1iupajsv3kp7e" data-mpi={index}>
                  <CheckCircleIcon className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-144" data-mp="1nsh0wig3g39h" />
                  <span data-id="element-145" data-mp="2ud052jv8s3qf">{point}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};
export default ComparisonSection;